export function getProductSchemaData(ad, image, canonical) {
  if (!ad?.Specification || !ad?.Prices) return { valid: false }

  const { Specification: spec } = ad
  const price = Number.parseFloat(ad.Prices.Price)
  const hasImage = typeof image === 'string' && image.length > 0

  const hasName = Boolean(spec.Title)
  const hasPrice = Number.isFinite(price) && price > 0
  const hasCanonical = Boolean(canonical)

  return {
    valid: hasName && hasImage && hasPrice && hasCanonical,
    price,
    image: hasImage ? image : undefined,
  }
}
